import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { coachLogin } from "../Redux/Actions/coachAction";
import { useSelector } from "react-redux";
export default function Footer() {

  const navigate=useNavigate()
  const { t } = useTranslation();
  const { offer, buttontext } = t("offerForm");
  const BottomMenu = t("BottomMenu");

  console.log(BottomMenu);

  const openPdf = () => {
    // window.open(pdfUrl, '_blank');
  };

   // // ======================================check for language=======================================

   const ingerman = useSelector((state) => state.homedata.selectedLang);
   console.log(ingerman);

   const authorizationUrl = `https://rest.cleverreach.com/oauth/authorize.php?client_id=OZQpK8wz1F&grant=basic&response_type=code&redirect_uri=https://mindrepublic.com`;


   const handleCleverReach=()=>{

    window.location.href = authorizationUrl;

   }

  
  return (
    <section className="footer-sec">
      <div className="footer-top-contain">
        <Container>
          <div className="footer-top">
            <Row className="align-center">
              <Col lg={6}>
                <h2 className="Platform-font">
                  {/* Stay Up to Date with All News and Exclusive Offers */}
                  {offer}
                </h2>
              </Col>
              <Col lg={6}>
                <div className="footer-form-input">
                  <InputGroup>
                    <Form.Control
                      placeholder={ingerman=="de"?"Geben ihre E-Mailadresse ein":"Enter email address"}
                      aria-label="Enter your email address"
                      aria-describedby="basic-addon2"
                    />
                    <InputGroup.Text style={{cursor:"pointer"}} onClick={handleCleverReach} id="basic-addon2">
                      {buttontext}
                    </InputGroup.Text>
                  </InputGroup>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div>

      <Container>
        <Row className="">
          <Col lg={3}>
            <div className="footer-first-box">
              <div className="footer-logo">
              <div className="main-logo-here">
                    <img src={require("../Assets/images/white-logo.png")} />
                  </div>
              </div>
              <p className="Platform-font">Love. Peace. Inner Growth.</p>

              <div className="social-media-icons">
                <ul>
                  <li>
                    <Link to="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M10.0001 0.0418701C4.47724 0.0418701 0 4.51911 0 10.042C0 14.9953 3.60522 19.0975 8.3322 19.8918V12.1282H5.91994V9.33437H8.3322V7.27437C8.3322 4.88414 9.7921 3.5816 11.9247 3.5816C12.9461 3.5816 13.8238 3.6577 14.0786 3.69123V6.18966L12.5995 6.19038C11.44 6.19038 11.2165 6.74126 11.2165 7.54994V9.33297H13.9832L13.6223 12.1268H11.2165V19.9586C16.1642 19.3565 20 15.1498 20 10.0391C20 4.51911 15.5228 0.0418701 10.0001 0.0418701Z"
                          fill="white"
                        />
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M20 20.0002V12.6752C20 9.07524 19.225 6.32524 15.025 6.32524C13 6.32524 11.65 7.42524 11.1 8.47524H11.05V6.65024H7.075V20.0002H11.225V13.3752C11.225 11.6252 11.55 9.95024 13.7 9.95024C15.825 9.95024 15.85 11.9252 15.85 13.4752V19.9752H20V20.0002ZM0.325001 6.65024H4.475V20.0002H0.325001V6.65024ZM2.4 0.000244141C1.075 0.000244141 0 1.07524 0 2.40024C0 3.72524 1.075 4.82524 2.4 4.82524C3.725 4.82524 4.8 3.72524 4.8 2.40024C4.8 1.07524 3.725 0.000244141 2.4 0.000244141Z"
                          fill="white"
                        />
                      </svg>
                    </Link>
                  </li>
                  <li>
                    <Link to="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M11.64 8.464L18.923 0H17.198L10.875 7.35L5.824 0H0L7.636 11.114L0 19.99H1.726L8.402 12.229L13.736 19.989H19.56L11.64 8.465V8.464ZM9.277 11.211L8.504 10.105L2.347 1.299H4.997L9.966 8.406L10.74 9.512L17.198 18.75H14.548L9.278 11.212L9.277 11.211Z"
                          fill="white"
                        />
                      </svg>
                    </Link>
                  </li>

                  <li>
                    <Link to="">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 20 20"
                        fill="none"
                      >
                        <path
                          d="M19.945 5.88032C19.898 4.81761 19.727 4.08707 19.48 3.45397C19.226 2.78201 18.836 2.1804 18.324 1.68026C17.824 1.17235 17.218 0.777664 16.554 0.527694C15.917 0.281554 15.19 0.109644 14.128 0.062834C13.057 0.0119641 12.717 0.000244141 10.002 0.000244141C7.287 0.000244141 6.947 0.0119641 5.88 0.0588541C4.817 0.105734 4.087 0.277724 3.454 0.523704C2.782 0.777664 2.18 1.16836 1.68 1.68026C1.172 2.18036 0.778 2.78595 0.527 3.45015C0.280998 4.08707 0.109001 4.8137 0.0619965 5.87633C0.012001 6.94697 0 7.28685 0 10.0022C0 12.7176 0.012001 13.0575 0.0589981 14.1241C0.105003 15.1868 0.277 15.9174 0.524002 16.5504C0.778 17.2224 1.172 17.824 1.68 18.3242C2.18 18.8321 2.786 19.2268 3.45 19.4767C4.087 19.7229 4.813 19.8948 5.876 19.9416C6.943 19.9886 7.283 20.0002 9.998 20.0002C12.713 20.0002 13.053 19.9886 14.12 19.9416C15.183 19.8947 15.913 19.7229 16.546 19.4767C17.211 19.2197 17.815 18.8267 18.319 18.3227C18.822 17.8188 19.216 17.2152 19.473 16.5504C19.719 15.9136 19.891 15.1868 19.938 14.1241C19.984 13.0575 19.996 12.7176 19.996 10.0022C19.996 7.28685 19.992 6.94694 19.945 5.88032ZM18.144 14.046C18.101 15.0227 17.937 15.5502 17.8 15.9018C17.464 16.7731 16.773 17.4646 15.902 17.8007C15.55 17.9374 15.019 18.1015 14.046 18.1444C12.991 18.1914 12.674 18.203 10.006 18.203C7.337 18.203 7.017 18.1914 5.966 18.1444C4.989 18.1015 4.462 17.9374 4.11 17.8007C3.677 17.6404 3.282 17.3865 2.961 17.0544C2.629 16.7301 2.375 16.3394 2.215 15.9058C2.078 15.5542 1.914 15.0227 1.871 14.05C1.824 12.9951 1.813 12.6785 1.813 10.01C1.813 7.34147 1.824 7.02113 1.871 5.97022C1.914 4.99346 2.078 4.46601 2.215 4.11438C2.375 3.68062 2.629 3.28605 2.965 2.9656C3.29 2.6335 3.68 2.37954 4.114 2.21947C4.466 2.08272 4.997 1.91863 5.97 1.87561C7.025 1.82873 7.341 1.81701 10.01 1.81701C12.682 1.81701 12.999 1.82873 14.05 1.87561C15.026 1.91867 15.554 2.08269 15.905 2.21943C16.339 2.37954 16.734 2.6335 17.054 2.9656C17.386 3.28992 17.64 3.68062 17.8 4.11438C17.937 4.46601 18.101 4.99725 18.144 5.97022C18.191 7.02512 18.203 7.34147 18.203 10.01C18.203 12.6785 18.191 12.9911 18.144 14.046Z"
                          fill="white"
                        />
                        <path
                          d="M10.002 4.86446C7.166 4.86446 4.864 7.16562 4.864 10.0022C4.864 12.8387 7.166 15.1399 10.002 15.1399C12.838 15.1399 15.14 12.8387 15.14 10.0022C15.14 7.16562 12.838 4.86446 10.002 4.86446ZM10.002 13.3349C8.162 13.3349 6.669 11.8424 6.669 10.0022C6.669 8.16194 8.162 6.6695 10.002 6.6695C11.842 6.6695 13.335 8.16194 13.335 10.0022C13.335 11.8424 11.842 13.3349 10.002 13.3349ZM16.542 4.66129C16.542 5.32369 16.005 5.86075 15.343 5.86075C14.68 5.86075 14.143 5.32369 14.143 4.66129C14.143 3.99881 14.68 3.46191 15.343 3.46191C16.005 3.46191 16.542 3.99877 16.542 4.66129Z"
                          fill="white"
                        />
                      </svg>
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
          <Col lg={3}>
            <div className="footer-list-box">
              <h3>{BottomMenu?.Company}</h3>
              <ul>
                <li>
                  <Link to="/about-the-app">{BottomMenu?.about}</Link>
                </li>
                <li>
                  {/* <Link to="#">{BottomMenu?.science}</Link> */}
                </li>
                <li>
                  <Link to="#">{BottomMenu?.aboutmr}</Link>
                </li>
                <li >
                  <Link to="/career" >{BottomMenu?.career}</Link>
                </li>
              </ul>
            </div>
          </Col>
          <Col lg={3}>
            <div className="footer-list-box">
              <h3>{BottomMenu?.help}</h3>
              <ul>
                <li>
                  <Link to="/contact">{BottomMenu?.contact}</Link>
                </li>
                <li>
                  <Link to="/terms-and-conditions">{BottomMenu?.gtc}</Link>
                </li>
                <li >
                  <Link  to="/access-agreement">{BottomMenu?.agreement}</Link>
                </li>
                <li>
                  <Link to="/data-protection">{BottomMenu?.data}</Link>
                </li>
                <li>
                  <Link to="/imprint">{BottomMenu?.Imprint}</Link>
                </li>
                <li>
                  <Link to="#">{BottomMenu?.Cookie}</Link>
                </li>
              </ul>
            </div>
          </Col>
          <Col lg={3}>
            <div className="footer-list-box">
              <h3>Links</h3>
              <ul>
                <li>
                  <Link to="#">{BottomMenu?.Language}</Link>
                </li>
                <li>
                  <Link to="/sign-up-as">{BottomMenu?.Login}</Link>


                  
                </li>
              </ul>
            </div>
          </Col>
          <Col lg={12}>
            <div className="copy-right-line">
              <p>©Mindrepublic 2024. All rights reserved.</p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
